// This is dependant on
//		inovestor.ms.web
//		inovestor.ms.core

; (function (inovestor, $, undefined) {

    inovestor.ms.web.ajaxProxy = new (function () {
        var originalMsAjaxMethod = inovestor.ms.core.ajaxApi;

        // Overwrite inovestor.ms.core.ajaxApi method so we can handle cases where cached data is already present.
        // If there's in data in the cache object for the current API call, just resolve a promise with the data.
        // Otherwise, call the original method as we don't have to temper with the call.
        inovestor.ms.core.ajaxApi = function (relativeUrl, options, apiBaseUrl) {
            var apiBaseUrlCopy = apiBaseUrl;

            // inovestor.ms.core.ajaxApi does some treatment on apiBaseUrl so we need to do the same...
            if (inovestor.ms.core.isNullOrUndefined(apiBaseUrlCopy))
                apiBaseUrlCopy = inovestor.ms.core.config.apiBaseUrl;

            var url = inovestor.ms.core.concatUrl(apiBaseUrlCopy, relativeUrl);

            // Because our URLs are case-insensitive, loop through all keys and compare in lowercase.
            // In our system, "Domain.com/Path" is the same as "domain.com/path".
            for (var key in inovestor.ms.web.dataCache) {
                if (key.toLowerCase() === url.toLowerCase()) {
                    var defer = $.Deferred();
                    var value = inovestor.ms.web.dataCache[key];
                    if (value) {
                        defer.resolve(value);
                        delete inovestor.ms.web.dataCache[key];
                        return defer.promise();
                    }
                }
            }

            // Could not find the key, execute the original ajax method
            return originalMsAjaxMethod(relativeUrl, options, apiBaseUrl);
        };
    })();

})(inovestor, jQuery);